import { isTrue } from '../../../utils/commonUtils';
import { BUTTON_DEFAULT_LABELS, BUTTON_TYPES } from '../../constants/form-manager.constants';

export const getButtonColor = (buttonType) => {
  let buttonStyle = {};

  switch (buttonType) {
    case BUTTON_TYPES.SAVE_OFFLINE:
    case BUTTON_TYPES.DELETE:
    case BUTTON_TYPES.SAVE_WITHOUT_SIGNOFF: // Save (no SignOff)
      buttonStyle = {
        color: 'primary',
        variant: 'secondary',
      };
      break;

    case BUTTON_TYPES.SAVE_AND_SIGNOFF: // Save AND SignOff
      buttonStyle = {
        color: 'primary',
        variant: 'primary',
      };
      break;

    case BUTTON_TYPES.CANCEL:
      buttonStyle = {
        variant: 'secondary',
      };
      break;

    default:
      buttonStyle = {
        color: 'primary',
        variant: 'primary',
      };
      break;
  }

  return buttonStyle;
};

export const labelCapitalFirstLetter = (label) => {
  return label.charAt(0).toUpperCase() + label.slice(1);
};

export const getDefaultButtonLabel = (buttonType) => BUTTON_DEFAULT_LABELS[buttonType] ?? 'button';

export const getButtonLabelToDisplay = ({
  translateString,
  formInfo,
  unsynchronizedEntityId,
  buttonType,
  propLabel,
  label,
}) => {
  if (
    ['true', 'false'].includes(formInfo.requiredESignature) &&
    buttonType === BUTTON_TYPES.SAVE_AND_SIGNOFF
  ) {
    if (isTrue(formInfo.requiredESignature)) {
      return translateString('Sign-off');
    }
  }

  const shouldUseUnsynchronizedLabel =
    unsynchronizedEntityId !== undefined &&
    [BUTTON_TYPES.OTHER, BUTTON_TYPES.SAVE_WITHOUT_SIGNOFF].includes(buttonType);

  if (shouldUseUnsynchronizedLabel) {
    return translateString('Synchronize');
  }

  return propLabel
    ? labelCapitalFirstLetter(label)
    : translateString(getDefaultButtonLabel(buttonType));
};
